import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import EditorComponent from './Editor';
import Register from './Register';
import StartDesign from './StartDesign';
import Generator from './Generator';
import Edit from './Edit';
import PlanOffer from './PlanOffer';
import PaymentCheck from './PaymentCheck';
function App() {
    const navigate = useNavigate();

    useEffect(() => {
        const user = localStorage.getItem('S:User');
        if (!user) {
            navigate('/register');
        }
    }, [navigate]);

    return (
        <Routes>
            <Route exact path="/" element={<Generator />} />
            <Route exact path="/generator" element={<Generator />} />
            <Route exact path="/generator/:slug" element={<Generator />} />
            <Route path="/editor/:slug" element={<EditorComponent />} />
            <Route path="/edit/:slug/:cardId" element={<Edit />} />
            <Route path="/register" element={<Register />} />
            <Route path="/start" element={<StartDesign />} />
            <Route path="/success" element={<PaymentCheck />} />
            <Route path="/offer" element={<PlanOffer />} />
        </Routes>
    );
}

export default function AppWrapper() {
    return (
        <Router>
            <App />
        </Router>
    );
}